
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { jkAlert, jkBaseLibClass, jkRestReturnClass, logger } from './jkClass';
import { jkRestReturn } from './jkInterface';

export function isNil(value: any): boolean {
  return value === null || value === undefined;
}

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));// FIXME: setTimeout 需加 cdr.markForCheck() 嗎？
}

export function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));// FIXME: setTimeout 需加 cdr.markForCheck() 嗎？
}


export function downloadURI(uri: string): void// 會轉到別的網頁 只能上一步回來 用iframe 比較好
{
  const link = document.createElement('a');
  //link.download = name;
  link.href = uri;
  link.click();
};

export function exitApp(platform: string): boolean {
  //let platform: string = "generic";
  if (confirm('你確定要離開嗎？')) { // TODO platform 判斷
    switch (platform) {// TODO
      case 'android':
        //    window.open('', '_self').close();  FIXME: 沒ionic 編譯不過
        break;
      case 'browser':
        setTimeout(() => {
          window.close;
          //this.cdr.markForCheck();  FIXME:    // 手動觸發變更檢測以符合 zoneless 模式
        }, 2000); // QQQ ??? still not work
        break;
      case 'generic':
        //window.opener = null; // 不要問
        // window.close();
        // close();
        //window.open('', '_self').close();  // Script 無法關閉非由 Script 開啟的視窗。 jklib.js:779:20

        setTimeout(window.close, 2000); // QQQ ??? still not work
        break;
      case 'win':
        // window.external.Notify("DevExpress.ExitApp");
        jkAlert('DevExpress.ExitApp', '');
        break;
      default:
      //jkAlert("real platform:" + DevExpress.devices.real().platform, "");
      //let p = getPlatform() TODO
    };
    return true;
  } else {
    return false;
  };

};


function fallbackCopyTextToClipboard(text: string) {
  var textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var successful = document.execCommand('copy');
    var msg = successful ? 'successful' : 'unsuccessful';
    console.log('Fallback: Copying text command was ' + msg);
  } catch (err) {
    console.error('Fallback: Oops, unable to copy', err);
  }

  document.body.removeChild(textArea);
}
export function copyTextToClipboard(text: string) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text);
    return;
  }
  navigator.clipboard.writeText(text).then(
    function () {

    },
    function (err) {
      console.error('Async: Could not copy text: ', err);
    }
  );
}

export class jkLibClass extends jkBaseLibClass {
  constructor() {
    super();
  }
  async geneSerialNo13(): Promise<string> {
    // also 可以當13碼序號 #sn #serialno
    await delay(2); // 避免執行太快而重複
    let n = Date.now();
    return n.toString();
  }
  loadLocalStorageItem(name: string, opt: any): boolean {
    var item = localStorage.getItem(name); // await 沒用?
    if (!item) {
      return false;
    }
    let obj = JSON.parse(item);
    Object.keys(obj).forEach((element) => {
      opt[element] = obj[element];
    });
    return true;
  }
  saveLocalStorageItem(id: string, obj: any) {
    let item = JSON.stringify(obj);
    localStorage.setItem(id, item);
  }
  html2Text(h: string): string {
    // TODO: test
    let temporalDivElement = document.createElement('div');
    // Set the HTML content with the providen
    temporalDivElement.innerHTML = h;
    // Retrieve the text property of the element (cross-browser support)
    return temporalDivElement.textContent || temporalDivElement.innerText || '';
  }
  text2Html(t: string): string {
    return this.swapStr(t, '\n', '<br>');
  }

  //===============
  // 與後端不同放前面
  //===============
  axiosConfigInit(host: string, path: string, method: string, params: any, data: any): AxiosRequestConfig {
    let config: AxiosRequestConfig;
    if (method.toLowerCase() === 'get') {
      config = {
        method: method,
        baseURL: host,
        url: path,
        headers: { 'Content-Type': 'application/json' },
        params: params
      };
    } else {
      config = {
        method: method,
        baseURL: host,
        url: path,
        headers: { 'Content-Type': 'application/json' },
        params: params,
        data: JSON.stringify(data)
      };
    }
    return config;
  }

  async doAxios(config: AxiosRequestConfig, ret: jkRestReturn) {
    let response;
    let retData;
    ret.clear();
    await axios(config)
      .then(function (res: AxiosResponse) {
        //ret = res.data;
        if (Array.isArray(res.data)) {
          ret.result = true;
          ret.obj = res.data;
          ret.rowsAffected = res.data.length;
        } else
          jkLib.cloneObject(res.data, ret);
        //ret.ok();
        //ret = retData;   //.assign(retData);  FIXME: TEST
        ret.request = config;
      })
      .catch(async function (error) {
        if (error.response) {
          response = error.response;
          if (response.data)
            ret.obj = response.data;
          ret.request = config;
          let msg = '';
          if (response.status && response.statusText) {
            msg = 'status:' + response.status + ' statusText:' + response.statusText;
            ret.addResultError(msg);
            ret.data = response.data;
          } else {
            ret.addResultError(JSON.stringify(error));
          }
        } else {
          ret.request = config;
          ret.addResultError(JSON.stringify(error));
        }
        alert(ret.errorLog);
        // doShowJson(ret.request); TODO: 改回來
        alert(JSON.stringify(ret.request));
      }).finally(() => {
        //console.log('finally');
      });
    return ret.result;
  }  /**
   *
   * @param host
   * @param basePath
   * @param urlParam
   * @param method
   * @param body
   * @returns
   */
  async doFetchOpt(url: string, opt: any): Promise<any> {
    //debugger
    const method = opt.method;
    if (method.toUpperCase() === 'GET') {
    }
    if (method.toUpperCase() === 'PUT') {
    }
    if (method.toUpperCase() === 'POST') {
    }
    if (method.toUpperCase() === 'DELETE') {
    }

    //const httpOptions = this.fetchOption(head, body, method, host)
    if (url.indexOf('login') > 0) {
      //logger.log('login url:' + opt.host+url);
    }
    let result;
    await fetch(url, opt)
      .then(this.checkStatus)
      .then((res: any) => res.json())
      .then((json: any) => (result = json))
      .catch((err: any) => {
        const msg = 'XXX 呼叫API失敗: ' + err.message + ' url:' + url;
        alert(msg);
        logger.error(msg);
      });

    if (method.toUpperCase() === 'GET') {
      return result;
    } else if (method.toUpperCase() === 'DELETE') {
      //logger.debug("DELETE result:", JSON.stringify(result))
      return result;
    } else {
      if (method.toUpperCase() === 'PUT') {
        //logger.debug("PUT result:", JSON.stringify(result))
        return result;
      } else {
        if (method.toUpperCase() === 'POST') {
          //logger.debug("POST result:", JSON.stringify(result))
          if (!result) return false;
          else return result;
        } else {
          return result;
        }
      }
    }
  }
  async doTestHost(oldHost: string, newHost: string): Promise<string> {
    // 參考 https://www.telerik.com/blogs/angular-basics-how-to-use-httpclient
    let result = await jkLib.doFetch(oldHost + '/api', '', '', '', 'get');
    if (result) {
      return oldHost;
    } else {
      return newHost;
    }
  }

  // 也能回傳 text
  async doFetch2(
    host: string,
    basePath: string,
    urlParam: string,
    token: string,
    method: string = 'GET',
    ret: jkRestReturn,
    body: any = {}
  ): Promise<any> {
    ret.clear();
    if (!host) {
      ret.addResultError('XXX 主機(host)未設定');
      return undefined;
    }
    let myUrl = basePath;
    if (basePath.indexOf('?') <= 0) {
      if (urlParam !== '') {
        myUrl += '?' + urlParam;
      }
    }

    const head: any = {
      'Content-Type': 'text/json',
      'Access-Control-Allow-Origin': '*',
      authorization: token,
    };

    const httpOptions = this.fetchOption(head, body, method, host);
    if (myUrl.indexOf('login') > 0) {
      logger.log('login url:' + host + myUrl);//, JSON.stringify(httpOptions)
    }
    let result;
    return await fetch(host + myUrl, httpOptions)
      .then(this.checkStatus)
      .then((res) => {
        const contentType = res.headers.get('content-type');
        if (contentType.includes('html')) {
          // text/plain text/html; charset=utf-8
          ret.ok();
          result = res.then((data: any) => {
            return data;
          });
          ret.obj = res;
          return res;
        }
        if (contentType.includes('application/json')) {
          ret.ok();
          ret.obj = res.json();
          //return res.json();
        }
      })
      .then((json: any) => {
        return json;
      })
      .finally(() => {
        console.log('ok');
      })
      .catch((err: any) => {
        const msg = 'XXX 呼叫API失敗: ' + err.message + ' url:' + host + myUrl;
        alert(msg);
        logger.error(msg);
        ret.addResultError(msg);
        return undefined;
      });
  }

  async doFetch(
    host: string,
    basePath: string,
    urlParam: string,
    token: string,
    method: string = 'GET',
    body: any = {}
  ): Promise<any> {
    //debugger
    if (!host) {
      this.jkRet.clear();
      this.jkRet.addResultError('主機(host)未設定');
      alert('主機(host)未設定');
      return this.jkRet;
    }
    let myUrl = basePath;
    if (basePath.indexOf('?') <= 0) {
      if (urlParam !== '') {
        myUrl += '?' + urlParam;
      }
    }

    //this.logRequest(method, url, data);

    //let body: any = {};
    /*
    let head: any = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      "authorization": token
    }*/

    const head: any = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      authorization: token,
    };
    /*
    if (token !== '')
        head.authorization = token;
    */
    if (method.toUpperCase() === 'GET') {
    }
    if (method.toUpperCase() === 'PUT') {
    }
    if (method.toUpperCase() === 'POST') {
    }
    if (method.toUpperCase() === 'DELETE') {
    }

    const httpOptions = this.fetchOption(head, body, method, host);
    if (myUrl.indexOf('login') > 0) {

      logger.log('login url:' + host + myUrl);// , JSON.stringify(httpOptions)
    }
    let result;
    try {
      await fetch(host + myUrl, httpOptions)
        .then(this.checkStatus)
        .then((res: any) => res.json())
        .then((json: any) => (result = json))
        .catch((err: any) => {
          const msg =
            'XXX 呼叫API失敗(338): ' +
            err.message +
            ' url:' +
            host +
            myUrl +
            this.CR +
            JSON.stringify(httpOptions);
          alert(msg);
          logger.error(msg);
        });
    } catch (error: any) {
      const msg =
        'XXX 呼叫API失敗(345): ' +
        error.message +
        ' url:' +
        host +
        myUrl +
        this.CR +
        JSON.stringify(httpOptions);
      alert(msg);
      logger.error(msg);
    }

    if (method.toUpperCase() === 'GET') {
      return result;
    } else if (method.toUpperCase() === 'DELETE') {
      //logger.debug("DELETE result:", JSON.stringify(result))
      return result;
    } else {
      if (method.toUpperCase() === 'PUT') {
        //logger.debug("PUT result:", JSON.stringify(result))
        return result;
      } else {
        if (method.toUpperCase() === 'POST') {
          //logger.debug("POST result:", JSON.stringify(result))
          if (!result) return false;
          else return result;
        } else {
          // GET return
          //logger.debug("GET rows:", result.rowsAffected)
          return result;
        }
      }
    }
    /*
      .toPromise()
      .then((data: any) => {
        return method === "GET" ? data.data : data;
      })
      .catch(e => {
        throw e && e.error && e.error.Message;
      }); */
  }

  // TODO: 未測試完成 data={"where":"","order":"","key":"","values":""}.where data.
  async doFetchCRUD(
    host: string,
    url: string,
    token: string,
    method: string = 'GET',
    data: any = {}
  ): Promise<any> {
    //debugger
    let myUrl = url;
    if (url.indexOf('?') <= 0) {
      myUrl += '?';
    }
    //this.logRequest(method, url, data);

    let body: any = {};
    const head: any = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      authorization: token,
    };
    if (method.toUpperCase() === 'GET') {
      if (data.where) {
        //debugger;
        //head.where = data.where
        if (data.where !== '') {
          myUrl = myUrl + '&where=' + data.where;
        }
      }
      if (data.order) {
        //head.order = data.order;
        if (data.order !== '') {
          myUrl = myUrl + '&order=' + data.order;
        }
      }
    }
    if (method.toUpperCase() === 'PUT') {
      if (data.key) {
        //debugger;
        //head.where = data.where
        //myUrl = myUrl + "&key="+JSON.stringify(data.key)
        head.key = JSON.stringify(data.key);
      }
      body = data.values;
    }
    if (method.toUpperCase() === 'POST') {
      body = data.values;
    }
    if (method.toUpperCase() === 'DELETE') {
      //head.where = data.key
      myUrl = myUrl + '&key=' + JSON.stringify(data.key);
    }

    const httpOptions = this.fetchOption(head, body, method, host);

    let result: jkRestReturn = new jkRestReturnClass();
    await fetch(host + myUrl, httpOptions)
      .then(this.checkStatus)
      .then((res: any) => res.json())
      .then((json: any) => (result = json))
      .catch((err: any) => {
        alert(err.message);
        console.log('XXX doFetchCRUD ' + err.message);
      });

    if (method.toUpperCase() === 'GET') {
      return result.obj;
    } else if (method.toUpperCase() === 'DELETE') {
      //logger.debug("DELETE result:", JSON.stringify(result))
      return result.obj;
    } else {
      if (method.toUpperCase() === 'PUT') {
        //logger.debug("PUT result:", JSON.stringify(result))
        return result.obj;
      } else {
        if (method.toUpperCase() === 'POST') {
          //logger.debug("POST result:", JSON.stringify(result))
          if (!result) {
            return false;
          } else {
            return result.obj;
          }
        } else {
          // GET return
          //logger.debug("GET rows:", result.rowsAffected)
          return result.obj;
        }
      }
    }
    /*
      .toPromise()
      .then((data: any) => {
        return method === "GET" ? data.data : data;
      })
      .catch(e => {
        throw e && e.error && e.error.Message;
      }); */
  }
  log(msg: any): void {
    //this.logger.log(this.getTime(), msg); // 與後端不同
  }

  fetchOption(headers: any, body: any, method: string, host: string): any {
    // window.fetch GET不能有body
    //let ret = {headers:headers,body:JSON.stringify(body),
    let ret;
    // debugger;
    if (method.toLowerCase() === 'get') {
      ret = {
        headers: headers,
        method: method,
        host: host,
      };
    } else {
      ret = {
        headers: headers,
        body: JSON.stringify(body), // TODO: body 要stringify嗎?
        //body: body, // TODO: jackie 20200727 modi
        method: method,
        host: host,
      };
    }
    return ret;
  }
  fetchOption2(headers: any, body: any, method: string, host: string): any {
    // window.fetch GET不能有body
    //let ret = {headers:headers,body:JSON.stringify(body),
    let ret;
    // debugger;
    if (method.toLowerCase() === 'get') {
      ret = {
        headers: headers,
        method: method,
        host: host,
      };
    } else {
      ret = {
        headers: headers,
        //body: JSON.stringify(body), // TODO: body 要stringify嗎?
        body: body, // TODO: jackie 20200727 modi
        method: method,
        host: host,
      };
    }
    return ret;
  }

  /* eval 是危險的 先不要用
  jsDecode(input: string): string {
    try {
      return !/([^\\]'|\r|\n)/.test(input) ? eval('\'' + input + '\'') : false;
    } catch (e: any) {
      return '';
    }
  }
  */

  xqCsv2Obj(s: string) {
    let res: any = {};
    while (s !== '') {
      let a = this.cutToken(s, ',');
      s = a[1].trim();
      let s1 = a[0];
      let p = this.cutToken(s1, ':');
      let o1 = p[0];
      let o2 = p[1];
      res[o1] = o2;
    }

    return res;
  }
  //===============
  // 與後端不同放結束
  //===============

  makeOptionAll(obj: any): any {
    let copy = this.deepCopyArray(obj);
    copy.push({ id: '', name: '全部' });
    return copy;
  }

  YN2boolean(value: string): boolean {
    if (value === 'Y') return true;
    else return false;
  }
  tryParseJSONObject(jsonString: string) {
    try {
      var o = JSON.parse(jsonString);

      // Handle non-exception-throwing cases:
      // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
      // but... JSON.parse(null) returns null, and typeof null === "object",
      // so we must check for that, too. Thankfully, null is falsey, so this suffices:
      if (o && typeof o === 'object') {
        return o;
      }
    } catch (e: any) { }

    return false;
  }
  copy2Clipboard(text: string) {
    copyTextToClipboard(text);
  }
  showStar(s: string): string {
    if (s === 'Y') return '⭐';
    else return '☆';
  }
  showTag(s: string): string {
    if (s === 'Y') return '🏷️';
    else return '🔲';
  }
  showCheck(s: string): string {
    if (s === 'Y') return '✅';
    else return '🔲'; // 🔲  ⬜
  }
  showBookmark(s: string): string {
    if (s === 'Y') return '🔖';
    else return '';
  }
  row2column(item: any, columnLabel: any): any {
    let ary: any[] = [];
    Object.keys(item).forEach((e) => {
      let it = { 名稱: columnLabel[e], 代號: e, 值: item[e] };
      ary.push(it);
    });
    return ary;
  }
  getReturnField(obj: any, fields: string): any {
    let ret1 = {};
    let fieldList = fields.split(',');
    fieldList.forEach((e) => {
      (ret1 as any)[e] = obj[e];
    });
    return ret1;
  }
  emojiCheck(s: string, label: string): string {
    if (s === 'Y') return '✅ ' + label;
    else return '❎ ' + label;
  }
  getKeyValues2(values: any, keyFields: string[]): any {
    let r = {};
    if (!values) {
      throw new Error('getKeyValues values is null');
    }
    for (let i = 0; i < keyFields.length; i++) {
      let value = values[keyFields[i]];
      if (value === undefined) {
        let msg = '還沒選擇哪一筆!(getKeyValues value is undefined)';
        alert(msg);
        throw new Error(msg);
      }
      (r as any)[keyFields[i]] = value; // values[keyFields[i]];
    }
    return r;
  }
  extractUrl(content: string): string {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    let url = content.match(urlRegex);
    if (!url) return '';
    return url[0];
  }
  paramsAllEmpty(params: any[]): boolean {
    // 檢查所有參數是否都為空
    for (let i = 0; i < params.length; i++) {
      if ((typeof params[i] === 'string') && (params[i] !== '')) {
        return false;
      }
      if ((typeof params[i] === 'number') && (params[i] !== 0)) {
        return false;
      }
    }
    return true;

  }
  haveValue(value: any): boolean {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    if (typeof value === 'number') return value !== 0;
    if (typeof value === 'boolean') return value;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object' && Object.keys(value).length === 0) {
      // 也能同時擋掉空陣列 []
      return false;
    }
    return true;
  }
} // export class JkLibClass

export let jkLib: jkLibClass = new jkLibClass();
